module.exports = __webpack_public_path__ + "static/media/SG_Payslip_2.276d767d.png";